import type { Fetch } from '../../shared/types';
import type { EntitlementsCheck } from '../types';

export const getTriggerImplementation = (
  fetch: Fetch,
  taskCount: number,
  accountID: number
): Promise<EntitlementsCheck> =>
  fetch('v1/check-entitlements/', {
    params: {
      count: taskCount,
    },
    headers: {
      'x-account-id': `${accountID}`,
    },
    method: 'GET',
    mode: 'cors',
  });

export default getTriggerImplementation;
